<div class="block" [ngClass]="field.extraClass">
  <label>{{field.label}}<span class="required" *ngIf="field.required"> *</span></label>
  <div class="input-with-icon" *ngIf="field.icon">
    <div class="input-icon"><img [src]="baseImagePath + field.icon" width="14" height="14"
        [alt]="field.label" [title]="field.label" /></div>
    <input type="number" [value]="value" [placeholder]="field.placeholder" [disabled]="disabled"
      (input)="onChange($any($event.target).value)" (blur)="onTouched()" />
  </div>
  <input  *ngIf="!field.icon" type="number" [value]="value" [placeholder]="field.placeholder" [disabled]="disabled"
      (input)="onChange($any($event.target).value)" (blur)="onTouched()" />
  <small class="error" *ngIf="errorMessage">
    {{ errorMessage }}
  </small>
</div>